module.exports = __webpack_public_path__ + "static/android-d8d43df6a2b48dcddaf014a6ed28d209.svg";